module.exports = __webpack_public_path__ + "media/images/lb/214-3d2b4d945f4121b04efb245ff968f992.svg";